<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    mounted() {
      if (this.$route.path.endsWith(' ')) {
        let path = this.$route.path.trim();
        this.$router.replace({path: path})
      } else if (this.$route.path.endsWith('%20')) {
        let path = this.$route.path.substring(0, this.$route.path.length - 3);
        this.$router.replace({path: path})
      }
    }
  }
</script>

<style>
  #app {
    width: 100%;
    height: 100%;
    background: #fff;
  }
</style>
